import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPromptTextToVideo: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="prompt-text-to-video"><path d="M1.75 5.75V3.75H6H10.25V5.75" stroke="currentColor" strokeWidth="1.5"/><path d="M5.99994 3.75V11.25M5.99994 11.25H4M5.99994 11.25H8" stroke="currentColor" strokeWidth="1.5"/><path d="M5.75 15V20.25H20.25V5.75H14" stroke="currentColor" strokeWidth="1.5"/><path d="M11 16.5V9.5L16 13L11 16.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPromptTextToVideo;
